import { AfterViewInit, ViewChild, ElementRef, Input, Directive } from '@angular/core';
import * as d3 from 'd3';

@Directive()
export abstract class PieChartComponentBase implements AfterViewInit {
  constructor() {}

  @ViewChild('chart') chart: ElementRef;

  private _arcGenerator: any;
  private _host: any;
  private _svg: any;

  protected colors: string[] = ['#fff'];

  private _arcTween(newValues, i, element) {
    let interpolation = d3.interpolate(element.storedValues, newValues);
    element.storedValues = interpolation(0);
    return t => this._arcGenerator(interpolation(t));
  }

  private _createPie() {
    this._host = this.chart.nativeElement;
    let radius = Math.min(this._host.offsetWidth / 2, this._host.offsetHeight / 2);
    this._arcGenerator = d3
      .arc()
      .innerRadius(radius - radius * 0.1)
      .outerRadius(radius);

    this._svg = d3
      .select(this._host)
      .append('svg')
      .attr('viewBox', '0, 0, ' + this._host.offsetWidth + ', ' + this._host.offsetHeight)
      .append('g')
      .attr('transform', `translate(${this._host.offsetWidth / 2}, ${this._host.offsetHeight / 2})`);
  }

  private _getColorByIndex(index: number): string {
    return this.colors[index];
  }

  protected updatePie(values: number[]) {
    if (!this._host) return;

    const component = this;

    let pie = d3
      .pie()
      .sort(null)
      .value(x => x)(values);
    let arc = this._svg.selectAll('.arc').data(pie);

    arc.exit().remove();

    let arcEnter = arc.enter().append('g').attr('class', 'arc');

    arcEnter.append('path').attr('d', this._arcGenerator);
    d3.select(this._host)
      .selectAll('path')
      .data(pie)
      .attr('fill', (datum, index) => this._getColorByIndex(index))
      .attr('d', this._arcGenerator)
      .transition()
      .duration(750)
      .attrTween('d', function (this: any, newValues, i) {
        return component._arcTween(newValues, i, this);
      });
  }

  ngAfterViewInit() {
    this._createPie();
    this.updatePie([0, 1]);
  }
}
